<div id="eps">
  <NBFormSelect
    label="Select a bank"
    v-model="selectedbank"
    :options="bankOptions"
  />
</div>
